/** Threshold boundaries for price buckets (c/kWh incl. VAT). */
export const CHEAP_CENTS = 5;
export const EXPENSIVE_CENTS = 15;

/** CSS variable names per bucket — consumed in chart coloring and tile accent. */
export const BUCKET_COLOR_VARS = {
  cheap: '--accent-success',
  normal: '--accent-info',
  expensive: '--accent-warning',
} as const;

/** CSS variable used to color slots with negative prices in charts. */
export const NEGATIVE_PRICE_COLOR_VAR = '--accent-primary';

export type PriceBucket = 'cheap' | 'normal' | 'expensive';
